import React, {useEffect, useState, useMemo, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Icon from 'react-web-vector-icons';
import searchIcon from '../../assets/search-glass.png';
import PageBase from "../../components/PageBase";
import Datatable from "../../components/Datatable";
import * as campaignActions from "../../redux/Campaign/actions";
import Filters from "../../components/Filters";
import availableFilters from './availableFilters.js';
import LoadingPanel from "../../components/LoadingPanel";
import columns from './column.js';
import Button from "../../components/Button";
import PopupWin from "../../components/PopupWin";
import PopupButton from "../../components/PopupButton";
import EditCampaign from "./EditCampaign";
import constants from "../../utils/constants.js";
import filterIcon from '../../assets/components/filters/filter.svg';
import usePersistentFilters from '../../hooks/usePersistentFilters';
import { getDisplayFields, getDefaultFields } from '../../utils/fields/campaigns.js';
import ListManager from '../../components/ListManager';
import {createColumnConfigs} from '../../utils/fieldUtils.js';

import './Campaigns.scss';
import useColumnFilters from '../../hooks/useColumnFilters.js';
const Campaigns = props => {
	// const [sortBy, setSortBy] = useState('campaign_name');
	// const [sortOrder, setSortOrder] = useState('asc');
	const [loading, setLoading] = useState(true);
	const [editCampaign, setEditCampaign] = useState(null);
	const editCampaignRef = useRef(null);
	const [filterResetKey, setFilterResetKey] = useState(0);
	const [listColumns, setListColumns] = useState([]);
	const entityType = `${constants.DISPLAY_ENTITIES.CAMPAIGNS}`;
	// const [columnsFilter, setColumnsFilter] = useState(defaultCoulmns());
		const fieldsToUse = useMemo(() => {
		return createColumnConfigs(getDisplayFields(listColumns.length === 0,listColumns))
		}, [listColumns]);

	const dispatch = useDispatch();
	const navigate = useNavigate();
	const campaigns = useSelector(state => state.campaign).campaigns;
	const lastUpdated = useSelector(state => state.campaign).lastUpdated;

	const {
		search,
		setSearch,
		selectedFilters,
		setSelectedFilters,
		clearFilters: clearPersistentFilters
	} = usePersistentFilters('campaigns', '', []);
		const searchedData = useMemo(() => {
		if (!campaigns) return [];
		if (!search) return campaigns;
		const lowerSearch = search.toLowerCase();
		return campaigns.filter(f => f.campaign_name?.toLowerCase().includes(lowerSearch));
		}, [campaigns, search]);
	
	const {
		filters,
		sortBy,
		sortOrder,
		filteredData,
		handleFilterChange,
		resetWith,
		updateData,
		uniqueValuesByColumn,
		filterOrder
	} = useColumnFilters({
		data: searchedData||[],
		columns: fieldsToUse,
		storageKey: 'campaigns',
		initialState: {}
	});

	const editCampaignFooter = useMemo(() => (
		<PopupButton
			variant="primary"
			onClick={() => editCampaignRef.current?.save()}
		>
			Create
		</PopupButton>
	), []);

	useEffect(() => {
		if(selectedFilters.length > 0) return;
		const load = async () => {
			await dispatch(campaignActions.loadCampaigns([]));
			setLoading(false);
		};
		load();
	}, []);

	useEffect(() => {
		if(selectedFilters.length === 0) return;
		const load = async () => {
			setLoading(true);
			await dispatch(campaignActions.loadCampaigns(selectedFilters));
			setLoading(false);
		};
		load();
	}, [selectedFilters]);
		useEffect(() => {
			updateData(campaigns);
		}, [campaigns]);

	if(loading || campaigns == null) {
		return (
			<PageBase title="Campaigns" removeMargins hideRefresh>
				<LoadingPanel />
			</PageBase>
		)
	}

	const onRowClick = async (row, index) => {
		navigate(`/campaign/${row.campaign_id}`);
	};

	const updateFilter = (value) => {
		setSearch(value.toLowerCase());
	};

	const addFilter = filter => {
		const index = selectedFilters.findIndex(f => f.name === filter.name);

		if(index < 0) {
			setSelectedFilters([...selectedFilters, filter]);
		}
		else {
			const updated = [...selectedFilters];
			updated[index] = filter;
			setSelectedFilters(updated);
		}
	};

	const removeFilter = (filterToRemove) => {
		const filters = selectedFilters.filter(f => f.name !== filterToRemove.name);
		setSelectedFilters(filters);
	};

	const onClearFilters = () => {
		clearPersistentFilters();
	};

	const onCampaignSaved = async () => {
		setEditCampaign(null);
		setLoading(true);
		await dispatch(campaignActions.loadCampaigns(selectedFilters));
		setLoading(false);
	};		

	return (
		<PageBase title="Campaigns" removeMargins hideRefresh>

			<PopupWin
				closeOnEscape={false}
				closeOnDocumentClick={false}
				visible={editCampaign != null}
				onClose={() => setEditCampaign(null)}
				title="Campaign"
				titleStyle={{fontSize: '18px', margin: '0 0 25px 0'}}
				contentStyle={{width: '100%', height: '90%', padding: 0}}
				popupStyle={{width: '90%', maxWidth: '1600px', height: '84%', maxHeight: '800px', overflow: 'none'}}
				footerStyle={{borderTop: '1px solid #D3E1ED'}}
				footer={editCampaignFooter}>
				{ editCampaign && <EditCampaign ref={editCampaignRef} editCampaign={editCampaign} onClose={onCampaignSaved} /> }
			</PopupWin>


			<div className="campaigns-header">
				<div className="campaigns-search-box">
					<img alt="" src={searchIcon} style={{padding: '0 10px'}} />
					<input className="campaigns-search-input" type="text" value={search} onChange={e => updateFilter(e.target.value)} placeholder="Search Campaigns..." />
				</div>
				<Filters availableFilters={availableFilters} clearFilters={onClearFilters} selectedFilters={selectedFilters} onAddFilter={addFilter} onRemoveFilter={removeFilter} />
				
				<div style={{ width: '10px' }}></div>
{/* <Button type="blue" width={220} leftIcon={filterIcon} onClick={openColumnsFilter}>Select displayed columns</Button> */}
				<div className="campaigns-header-buttons">
					<ListManager
						entityType={entityType}
						displayFields={getDisplayFields()}
						defaultFields={getDisplayFields(true).map(f => f.field)}
						onColumnsChange={setListColumns}
					/>
					
					<Button onClick={() => setEditCampaign({})} type="blue" center>
						<Icon name="plus" font="AntDesign" size={16} color="white" /> Add Campaign
					</Button>
				</div>
			</div>

			{selectedFilters.length > 0 && (
				<div style={{margin: '0 30px'}}>
					<p style={{ color: '#062229', fontWeight: 700, fontSize: 14 }}>Found {filteredData?.length || 0} Campaigns</p>
				</div>
			)}

			<div style={{margin: '0 30px'}}>
				<Datatable 
					gridHeight="calc(100vh - 185px)"
					tableName={`campaigns`}
					columns={fieldsToUse}
					data={filteredData}
					key={filterResetKey}
					//onSort={updateSort}
					sortBy={sortBy}
					sortOrder={sortOrder}
					onRowClick={onRowClick}
					filters={filters}
					onFilterChange={handleFilterChange}
					filterOrder={filterOrder}
					uniqueValuesByColumn={uniqueValuesByColumn}
					allData={campaigns}
				/>
			</div>
		</PageBase>
	)
};

export default Campaigns;
